import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ContactAdminModalComponent } from './contact-admin-modal.component';

@NgModule({
  declarations: [ContactAdminModalComponent],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [ContactAdminModalComponent]
})
export class ContactAdminModalModule {} 